module.exports = __webpack_public_path__ + "img/ic-spklu-white.a9537823.svg";